let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("luYx3")).then(() => parcelRequire('1gtOK'));